import React from 'react'
import PageLayout from '../components/templates/page-layout/page-layout'
import AppMenu from '../components/atoms/app-menu/app-menu'
import VideosSection from '@/components/organisms/videos-section/videos-section'
import MainBanner from '@/components/organisms/main-banner/main-banner'
import ModalViewer from '@/components/organisms/modal-viewer/modal-viewer'
import SignSection from '@/components/organisms/sign-section/sign-section'
import ConsultingSection from '@/components/organisms/consulting-section/consulting-section'
import DownloadSection from '@/components/organisms/download-section/download-section'
import FloatingButton from '@/components/organisms/floating-button/floating-button'
import ForumSection from '@/components/organisms/forum-section/forum-section'
import FooterLoving from '@/components/molecules/footer-loving/footer-loving'
import { LOCALE_AT } from '@/constants/activity-constants'
import { initTagging } from '@/utils/tagging-util'
import CrazyEgg from '@/utils/CrazyEgg'
const links = {
  inicio: 'Inicio',
  'video-expertas': 'Video expertas',
  consultorios: 'Consultorio gratuito',
  descargables: 'Descargables',
  firma: 'Únete a la campaña',
  foro: 'Foro',
}
if (LOCALE_AT.PARAGUAY) {
  links.firma = 'Unite a la campaña'
}
initTagging()

function IndexPage() {
  return (
    <PageLayout>
      <CrazyEgg />
      <AppMenu links={links} />

      <MainBanner id="inicio" />

      <VideosSection id="video-expertas" />
      <section id="consultorios">
        <ConsultingSection />
      </section>
      <section id="descargables">
        <DownloadSection />
      </section>
      <SignSection id="firma" />

      <ForumSection id="foro" />

      <FloatingButton />
      <FooterLoving />
      <ModalViewer />
    </PageLayout>
  )
}

export default IndexPage
